/**
 * 아이콘은 24px 정사각에 획 굵기 1.5px이고 색은 currentColor를 따른다. 한 기호가 한 뜻만
 * 가지므로 같은 그림을 다른 자리에서 다른 뜻으로 돌려 쓰지 않는다.
 *
 * 대체 텍스트를 비운다. 접근성 이름은 이 아이콘을 감싸는 버튼이 갖는다.
 */
function Icon({ children, size = 24 }: { children: React.ReactNode; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className="shrink-0"
    >
      {children}
    </svg>
  )
}

/** 앞 화면으로 돌아간다. */
export function ArrowLeftIcon() {
  return (
    <Icon>
      <path d="M15 5 8 12l7 7" />
    </Icon>
  )
}

/**
 * 설정으로 간다.
 *
 * 톱니를 고른 근거는 설정을 뜻하는 기호 가운데 가장 널리 통하고 다른 뜻으로 읽힐 여지가 적다는
 * 것이다. 세 줄은 목록이 열린다는 뜻이고 점 셋은 기록 상세의 메뉴가 이미 쓴다.
 */
export function GearIcon() {
  return (
    <Icon>
      <circle cx="12" cy="12" r="3.1" />
      <path d="M12 2.9v2.2M12 18.9v2.2M21.1 12h-2.2M5.1 12H2.9M18.44 5.56l-1.56 1.56M7.12 16.88l-1.56 1.56M18.44 18.44l-1.56-1.56M7.12 7.12 5.56 5.56" />
    </Icon>
  )
}

/**
 * 누르면 무엇인가 열린다. 열리는 것이 화면인지 시트인지는 가르지 않는다.
 *
 * 행 안에서 값 다음에 서는 자리라 16px이다. 장식이므로 행이 이미 갖는 이름 밖에 이름을 두지
 * 않는다.
 */
export function ChevronRightIcon() {
  return (
    <Icon size={16}>
      <path d="M9.5 5.5 16 12l-6.5 6.5" />
    </Icon>
  )
}

/** 덮은 층이나 우리가 꺼낸 말을 걷는다. 화면을 옮기는 자리에 쓰지 않는다. */
export function CloseIcon() {
  return (
    <Icon>
      <path d="M6 6l12 12M18 6 6 18" />
    </Icon>
  )
}
